export const SORT_ITEMS = [
    { value: 'code-asc', name: 'Código de menor a mayor' },
    { value: 'code-dec', name: 'Código de mayor a menor' },
    { value: 'import-asc', name: 'Importe Menor a Mayor (1-10)' },
    { value: 'import-dec', name: 'Importe Mayor a Menor (10-1)' },
    { value: 'amount-asc', name: 'Cantidad de Menor a Mayor' },
    { value: 'amount-dec', name: 'Cantidad de Mayor a Menor' },
  ];